import { createApiRef } from '@backstage/core-plugin-api';
import { OpsicleApi } from './OpsicleApiClient';

export const opsicleApiRef = createApiRef<OpsicleApi>({
  id: 'plugin.opsicle.service',
});
